<div class="map-footer" [style.margin-right]="homeComponent.sidenavView?'57px':'0' "
    [style.width]="homeComponent.activatedViewPanoramic? homeComponent.splitAreaSizeMap+'%':'100%'">
    <div id="coordenadas" class="coordenadas"></div>
    <div id="scaleBar" class="scaleBar"></div>
</div>

<!-- <div class="details">
    <span style="font-size: smaller;color: white;">RealView© - Powered by Realidad 5.0</span>
</div> -->
<!-- <div class="info">
    <div class="details">
        <span style="font-size: smaller;" *ngIf="mapService.actuallyForm == ''">Espacio de Trabajo no seleccionado</span>
    <mat-icon *ngIf="mapService.actuallyForm != ''" inline="true" matTooltip="Categoria">category</mat-icon>
    <mat-label>{{mapService.actuallyCategory}}</mat-label>
    </div>
    <div class="details">
        <mat-icon *ngIf="mapService.actuallyForm != ''" inline="true" matTooltip="Capa">layers</mat-icon>
        <mat-label>{{mapService.actuallyLayer}}</mat-label>
        </div>
        <div class="details">
            <mat-icon *ngIf="mapService.actuallyForm != ''" inline="true" matTooltip="Formulario">assignment</mat-icon>
            <mat-label>{{mapService.actuallyForm}}</mat-label>
            </div>
  </div> -->